export const formatBreakline = (text: string): string => {
    return text.replace(/\n/g, '<br />')
}
